import * as yup from 'yup';
import ValidationMessage from '../../constants/ValidationMessage';
const ChangePasswordValidation: any = yup.object().shape({
    old_password: yup.string().required(ValidationMessage.PASSWORD_REQUIRED)
        .min(8, ValidationMessage?.PASSWORD_MIN_CHAR)
        .max(15, ValidationMessage?.PASSWORD_MAX_CHAR)
        .matches(/^\S*$/, ValidationMessage?.NO_SPACE_ALLOWED)
        // .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~`!@#$%^&.,<>?/*:";'{}()=\[\]+_\-])[A-Za-z\d~`!@#$%^&.,<>?/*:";'{}()\[\]=+_\-]{8,15}$/, ValidationMessage?.PASSWORD_UPPER_CASE),
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/, ValidationMessage?.PASSWORD_UPPER_CASE),


    // password: yup.string().required(ValidationMessage.Field("new password"))
    //     .min(8, ValidationMessage?.MinLength('New password', 8))
    //     .max(15, ValidationMessage?.MaxLength('New password', 15))
    //     .matches(/^\S*$/, ValidationMessage?.NO_SPACE_ALLOWED)
    //     .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~`!@#$%^&.,<>?/*:";'{}()=\[\]+_\-])[A-Za-z\d~`!@#$%^&.,<>?/*:";'{}()\[\]=+_\-]{8,15}$/, ValidationMessage?.PASSWORD_UPPER_CASE),


    password: yup.string().required(ValidationMessage.NEW_PASSWORD_REQUIRED)
        .min(8, ValidationMessage?.PASSWORD_MIN_CHAR)
        .max(15, ValidationMessage?.PASSWORD_MAX_CHAR)
        .matches(/^\S*$/, ValidationMessage?.NO_SPACE_ALLOWED)
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/, ValidationMessage?.PASSWORD_UPPER_CASE),


    confirm_password: yup.string().required(ValidationMessage.RE_ENTER_PASSWORD)
        .min(8, ValidationMessage?.PASSWORD_MIN_CHAR)
        .max(15, ValidationMessage?.PASSWORD_MAX_CHAR)
        .oneOf([yup.ref('password')], ValidationMessage?.PASSWORD_CONFIRM_PASSWORD_MUST_MATCH),
});

export default ChangePasswordValidation;

